<template>
  <div>
    <section class="banner_box">
      <div id="bigBox" class="bannerTitleBox">
        <div
          class="bannerTitle"
          :style="
            bannerIndex == 0 ? 'text-align: center;' : 'text-align: left;'
          "
        >
          <h1 :style="bannerIndex == 0 ? 'color: #fff;font-weight: 400;' : ''">
            {{
              bannerIndex == 0 ? "中国企业数智化运营服务商" : "润信数字智能科技"
            }}
          </h1>
          <p v-show="bannerIndex != 0">AI赋能千行百业</p>
          <button class="bannerTitleAcitve" v-if="bannerIndex == 0">
            了解更多
          </button>
          <button class="bannerBtn" v-else>立即查看</button>
        </div>
      </div>
      <div class="swiper_box">
        <el-carousel
          arrow="always"
          height="80vh"
          trigger="click"
          @change="bannerChange"
          indicator-position="none"
        >
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <img :src="item.image" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <section id="bigBox" class="page_nav" :class="{ fixed: navFixed }">
        <ul>
          <li
            :class="{ active: activeNav === 0 }"
            @click="navClick(0, 'service_box')"
          >
            企业核心服务架构
          </li>
          <li
            :class="{ active: activeNav === 1 }"
            @click="navClick(1, 'business_box')"
          >
            业务范围
          </li>
          <li
            :class="{ active: activeNav === 2 }"
            @click="navClick(2, 'teacher_box')"
          >
            师资展示
          </li>
          <li
            :class="{ active: activeNav === 3 }"
            @click="navClick(3, 'customer_box')"
          >
            客户案例
          </li>
          <li
            :class="{ active: activeNav === 4 }"
            @click="navClick(4, 'cooperation_box')"
          >
            合作企业
          </li>
        </ul>
      </section>
    </section>

    <div id="bigBox">
      <!-- 企业核心服务架构 -->
      <section class="service_box module_box" id="service_box">
        <h1 class="main_title">企业核心服务架构</h1>
        <div class="swiper-container sub_module_box">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img :src="$utils.formatImgUrl('companyImg1.jpg')" alt="" />
              <h3 class="sub_title">业务介绍</h3>
              <p>
                聚焦企业数智化转型，提供全链路经营解决方案，助力企业降本增效、数字化升级。
              </p>
            </div>
            <div class="swiper-slide">
              <img :src="$utils.formatImgUrl('companyImg2.jpg')" alt="" />
              <h3 class="sub_title">服务范围</h3>
              <p>
                覆盖数字化系统搭建、流程优化、数据赋能、运营提效全场景，适配多行业企业需求。
              </p>
            </div>
            <div class="swiper-slide">
              <img :src="$utils.formatImgUrl('companyImg3.jpg')" alt="" />
              <h3 class="sub_title">核心能力</h3>
              <p>
                以自研技术为核心，打造高效、可落地的数智化经营体系，赋能企业全链路数字化。
              </p>
            </div>
            <div class="swiper-slide">
              <img :src="$utils.formatImgUrl('companyImg4.jpg')" alt="" />
              <h3 class="sub_title">优势特点</h3>
              <p>
                深耕企业服务领域，以定制化方案、专业技术团队，为企业提供高适配、高价值的数智化服务。
              </p>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </section>

      <!-- 业务范围 -->
      <section class="business_box module_box" id="business_box">
        <h1 class="main_title">业务范围</h1>
        <ul class="business_list sub_module_box">
          <li v-for="(item, index) in businessList" :key="index">
            <div>
              <h1>{{ item.businessTitle }}</h1>
              <p>
                {{ item.businessDesc }}
              </p>
            </div>
            <img :src="$utils.formatImgUrl(item.imgUrl)" alt="" />
          </li>
        </ul>
      </section>
      <!-- 师资展示 -->
      <section class="teacher_box module_box" id="teacher_box">
        <h1 class="main_title">课程师资</h1>
        <div
          class="teacher_info sub_module_box"
          :style="
            'background: url(' +
            $utils.formatImgUrl('homeTeacher.png') +
            ') no-repeat;'
          "
        >
          <h1>我们的团队</h1>
          <p>
            我们是专注企业数智化转型的专业团队，以 “数智化 + AI
            让企业经营更轻松” 为使命，深耕企业数智化运营服务，助力企业高效经营。
          </p>
          <button class="theme_color" @click="$utils.goPage('/teacher')">
            立即查看
          </button>
        </div>
      </section>

      <!-- 客户案例 -->
      <section class="customer_box module_box" id="customer_box">
        <h1 class="main_title">客户案例</h1>
        <ul class="customer_list sub_module_box">
          <li
            class="customer_item"
            :class="{ active: activeItem === 1 }"
            @mouseenter="activeItem = 1"
          >
            <img
              style="width: 160px"
              src="../assets/img/cusromerLogo1.png"
              alt=""
            />
            <h3>90%+</h3>
            <h4>业务运营时效提升</h4>
            <p>
              搭建数智化 AI
              智能运营管理系统，小团队即可支撑全业务高效运转。立项审批、课程交付、差旅财务、品牌展示全流程自动化，实现当日执行、当日复盘、当日出数据，让企业培训运营更高效。
            </p>
            <img src="../assets/img/cusetomerImg4.png" alt="" />
          </li>
          <li
            class="customer_item"
            :class="{ active: activeItem === 2 }"
            @mouseenter="activeItem = 2"
          >
            <img
              style="width: 150px"
              src="../assets/img/cusromerLogo2.png"
              alt=""
            />
            <h3>90%+</h3>
            <h4>生产情报时效提升</h4>
            <p>
              借助钉钉 AI 表格 +
              生产数字化管理系统，搭建数字化智能工厂，核心团队即可支撑内外胎全制程高效运转。生产报工、仓储流转、质量追溯、OA
              审批全流程自动化，实现当日排产、当日完工、当日复盘，让生产协同更高效。
            </p>
            <img src="../assets/img/cusetomerImg3.png" alt="" />
          </li>
          <li
            class="customer_item"
            :class="{ active: activeItem === 3 }"
            @mouseenter="activeItem = 3"
          >
            <img
              style="width: 180px"
              src="../assets/img/cusromerLogo3.png"
              alt=""
            />
            <h3>90%+</h3>
            <h4>研发数据时效提升</h4>
            <p>
              搭建研发管理数智化平台，核心团队即可支撑材料 / 工程 /
              模具全流程研发。配方录入、模具排产、项目管控、知识沉淀全流程自动化，实现当日立项、当日跟进、当日可追溯，让研发协同更高效。
            </p>
            <img src="../assets/img/cusetomerImg2.png" alt="" />
          </li>
          <li
            class="customer_item"
            :class="{ active: activeItem === 4 }"
            @mouseenter="activeItem = 4"
          >
            <img
              style="width: 130px"
              src="../assets/img/cusromerLogo4.png"
              alt=""
            />
            <h3>90%+</h3>
            <h4>经营数据时效提升</h4>
            <p>
              搭建全链路数字化经营平台，核心团队即可支撑设计 - 生产 - 销售 -
              供应链 -
              财务全链条运转。人事管理、订单协同、生产跟踪、库存预警、财务分析全流程自动化，实现当日开单、当日跟进、当日闭环，让珠宝经营协同更高效。
            </p>
            <img src="../assets/img/customerImg1.png" alt="" />
          </li>
        </ul>
      </section>
    </div>

    <section class="cooperation_box module_box" id="cooperation_box">
      <h1 class="main_title">合作企业</h1>
      <ul class="cooperation_list sub_module_box">
        <li class="cooperation_item" ref="row1">
          <div class="scroll-box">
            <div class="scroll-content" ref="content1">
              <img
                alt=""
                v-for="(i, idx) in imgList[0]"
                :key="idx"
                :src="i"
                @mouseenter="stop(1)"
                @mouseleave="run(1)"
              />
            </div>
          </div>
        </li>
        <li class="cooperation_item" ref="row2">
          <div class="scroll-box">
            <div class="scroll-content" ref="content2">
              <img
                alt=""
                v-for="(i, idx) in imgList[1]"
                :key="idx"
                :src="i"
                @mouseenter="stop(2)"
                @mouseleave="run(2)"
              />
            </div>
          </div>
        </li>
        <li class="cooperation_item" ref="row3" style="margin-bottom: 0">
          <div class="scroll-box">
            <div class="scroll-content" ref="content3">
              <img
                alt=""
                v-for="(i, idx) in imgList[2]"
                :key="idx"
                :src="i"
                @mouseenter="stop(3)"
                @mouseleave="run(3)"
              />
            </div>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  components: {},
  name: "Home",
  data() {
    return {
      activeItem: 0,
      activeNav: 0,
      navFixed: false,
      navTop: 0,
      bannerIndex: 0,
      bannerList: [],
      bannerConfig: {
        mainTitle: "这是大标题", // 主标题
        subTitle: "这是小标题", // 副标题
        btnText: "这是按钮文本内容", // 按钮文本
        mainTitleStyle: {
          // 主标题样式
          color: "red",
          fontWeight: "400",
        },
        subTitleStyle: {
          // 副标题样式
          color: "red",
          fontWeight: "400",
        },
        btnStyle: {
          // 按钮样式
          color: "#fff",
          backgroundColor: "#000",
        },
        imgUrl: ["", ""], // 图片地址列表
      },
      businessList: [
        {
          id: 1, // 业务ID
          businessTitle: "企业数智化整体解决方案", // 业务标题
          businessDesc:
            "提供组织数智化、业务数智化、智能决策全链路方案，助力企业实现经营管理智能化升级", // 业务描述
          imgUrl: "businessScopeImg1.png", // 业务图片
        },
        {
          id: 2, // 业务ID
          businessTitle: "组织协同与智能人事管理", // 业务标题
          businessDesc:
            "涵盖智能办公、OA流程、人事绩效、团队协同、企业文化建设、安全合规管控等服务", // 业务描述
          imgUrl: "businessScopeImg2.png", // 业务图片
        },
        {
          id: 3, // 业务ID
          businessTitle: "全业务流程数字化搭建", // 业务标题
          businessDesc:
            "覆盖项目、生产、销售、供应链、库存、售后等全业务场景，实现流程线上化与一体化管理", // 业务描述
          imgUrl: "businessScopeImg3.png", // 业务图片
        },
        {
          id: 4, // 业务ID
          businessTitle: "系统集成与定制技术开发", // 业务标题
          businessDesc:
            "提供 ERP/MES/CRM 等多系统打通、API 对接、低代码搭建、小程序及酷应用开发服务", // 业务描述
          imgUrl: "businessScopeImg4.png", // 业务图片
        },
        {
          id: 5, // 业务ID
          businessTitle: "AI 数据决策与财务数智化", // 业务标题
          businessDesc:
            "包含经营数据分析、智能报表、全面预算、费控管理、财务共享与风险控制服务", // 业务描述
          imgUrl: "businessScopeImg5.png", // 业务图片
        },
        {
          id: 6, // 业务ID
          businessTitle: "全域电商运营与落地赋能", // 业务标题
          businessDesc:
            "提供智能办公设备配套、新媒体运营、全流程实施部署及企业培训落地服务", // 业务描述
          imgUrl: "businessScopeImg6.png", // 业务图片
        },
      ],
      // 合作企业图片列表
      cooperationList: ["", ""],
      imgList: [[], [], []],
    };
  },
  created() {
    // 生成18个图片地址并添加到imgList
    for (let i = 1; i <= 17; i++) {
      this.imgList[0].push(require(`../assets/img/homeBarrageImg/img${i}.png`));
      this.imgList[1].push(require(`../assets/img/homeBarrageImg/img${i}.png`));
      this.imgList[2].push(require(`../assets/img/homeBarrageImg/img${i}.png`));
      this.imgList[0].sort(() => Math.random() - 0.5);
      this.imgList[1].sort(() => Math.random() - 0.5);
      this.imgList[2].sort(() => Math.random() - 0.5);
    }
  },
  beforeMount() {
    this.bannerList = JSON.parse(localStorage.getItem("imgUrlList")).web_index;
  },
  mounted() {
    // 你的swiper不动 保持原样
    new this.$Swiper(".swiper-container", {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: { el: ".swiper-pagination", clickable: true },
    });

    // ✅ 滚动速度在这里调！
    this.initScroll(1, 0.8); // 第一行
    this.initScroll(2, 1); // 第二行
    this.initScroll(3, 1.5); // 第三行

    // 添加滚动事件监听
    window.addEventListener("scroll", this.handleScroll);

    // 获取page_nav元素的初始位置，确保DOM完全渲染后再获取
    setTimeout(() => {
      const navElement = document.querySelector(".page_nav");
      if (navElement) {
        this.navTop = navElement.offsetTop;
        // 页面刷新后检查滚动位置，更新导航栏状态
        this.handleScroll();
      }
    }, 100);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    bannerChange(index) {
      this.bannerIndex = index;
    },
    navClick(index, targetId) {
      // 更新激活状态
      this.activeNav = index;
      // 标记正在滚动，防止滚动事件触发
      this.isScrolling = true;
      // 滚动到对应模块
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        // 计算滚动位置，考虑固定导航栏的高度
        const navHeight = 90; // 顶部导航栏高度
        const pageNavHeight = 80; // page_nav高度
        const rect = targetElement.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop - navHeight - pageNavHeight; // 20为额外间距

        // 平滑滚动到指定位置
        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });

        // 滚动结束后重置标记
        setTimeout(() => {
          this.isScrolling = false;
        }, 1000); // 1秒后滚动应该完成
      }
    },
    handleScroll() {
      // 获取滚动位置
      const scrollTop = window.scrollY;

      // 只有当navTop被正确设置后才进行导航栏状态判断
      if (this.navTop > 0) {
        // 处理page_nav固定定位
        if (scrollTop >= this.navTop - 90) {
          // 90是顶部导航栏的高度
          this.navFixed = true;
        } else {
          this.navFixed = false;
        }

        // 处理顶部导航栏显示/隐藏
        const myNav = document.querySelector(".my_nav");
        if (myNav) {
          if (this.navFixed) {
            myNav.style.opacity = "0";
            myNav.style.transform = "translateY(-100%)";
          } else {
            myNav.style.opacity = "1";
            myNav.style.transform = "translateY(0)";
          }
        }
      }

      // 检测当前滚动位置对应的模块，更新导航激活状态
      if (!this.isScrolling) {
        const modules = [
          { id: "service_box", index: 0 },
          { id: "business_box", index: 1 },
          { id: "teacher_box", index: 2 },
          { id: "customer_box", index: 3 },
          { id: "cooperation_box", index: 4 },
        ];

        const navHeight = 90; // 顶部导航栏高度
        const pageNavHeight = 80; // page_nav高度
        const offset = navHeight + pageNavHeight + 20; // 偏移量

        for (const module of modules) {
          const element = document.getElementById(module.id);
          if (element) {
            const rect = element.getBoundingClientRect();
            // 当模块顶部进入可视区域时，更新激活状态
            if (rect.top <= offset && rect.bottom >= offset) {
              this.activeNav = module.index;
              break;
            }
          }
        }
      }
    },
    // ✅ 修复完整版：调速生效
    initScroll(row, speed) {
      const content = this.$refs[`content${row}`];
      const parent = content.parentNode;
      const clone = content.cloneNode(true);
      parent.appendChild(clone);

      this[`pos${row}`] = 0;
      this[`stop${row}`] = false;

      const anim = () => {
        if (this[`stop${row}`]) {
          requestAnimationFrame(anim);
          return;
        }

        // ✅ 速度在这里生效了
        this[`pos${row}`] -= speed;

        const w = content.offsetWidth;
        if (Math.abs(this[`pos${row}`]) >= w) {
          this[`pos${row}`] += w;
        }

        content.style.transform = `translateX(${this[`pos${row}`]}px)`;
        clone.style.transform = `translateX(${this[`pos${row}`]}px)`;

        requestAnimationFrame(anim);
      };
      anim();
    },
    stop(row) {
      this[`stop${row}`] = true;
    },
    run(row) {
      this[`stop${row}`] = false;
    },
  },
};
</script>

<style scoped lang="less">
.service_box,
.business_box,
.teacher_box,
.customer_box {
  width: 100%;
  padding: 0 8%;
  box-sizing: border-box;
}
.bannerTitle {
  text-align: center;
  color: #fff;
  overflow: hidden;

  > h1 {
    font-size: 1.5rem;
    margin: 0 0 20px 0;
    line-height: 1.2;
    word-wrap: break-word;
  }

  > p {
    font-size: 0.8rem;
    margin: 0 0 40px 0;
    word-wrap: break-word;
  }

  > button {
    font-size: 0.9rem;
  }
}

.bannerTitle {
  margin-top: 14rem;
  text-align: left;
}

.bannerTitle h1 {
  height: 3.375rem;
  font-size: 3.5rem;
  color: #222222;
  line-height: 4.625rem;
  letter-spacing: 0.125rem;
}

.bannerTitle p {
  font-size: 1.875rem;
  font-weight: 400;
  color: #333333;
  line-height: 2.25rem;
  margin: 2.18rem auto 2.5rem;
}

.bannerTitleBox button {
  width: 13.75rem;
  height: 3.75rem;
  font-size: 1.625rem;
  font-weight: 300;
  color: #ffffff;
  border-radius: 50px;
  letter-spacing: 4px;
  margin-top: 5rem;
}
.bannerBtn {
  background: linear-gradient(45deg, #00f090, #0099ff) !important;
}
.bannerTitleAcitve {
  border: 1px solid #fff !important;
  background: none !important;
  margin: 60px auto;
  font-size: 1.25rem;
  width: 180px;
}
.bannerTitle button:hover {
  cursor: pointer;
}

@media screen and (min-width: 1024px) {
  .bannerTitle {
    margin-top: 7rem;
  }
  .bannerTitle > h1 {
    font-size: 2.5rem;
    margin: 0 0 20px 0 !important;
  }
  .bannerTitle > p {
    font-size: 1.2rem;
    margin: 0 0 0 0;
  }
  .bannerTitle > button {
    font-size: 1.1rem;
    margin-top: 3rem;
  }
}

@media screen and (min-width: 1280px) {
  .bannerTitle {
    margin-top: 10rem;
  }
  .bannerTitle > h1 {
    font-size: 3rem;
    margin: 0 0 40px 0;
  }
  .bannerTitle > p {
    font-size: 1.4rem;
    margin: 0 0 10px 0;
  }
  .bannerTitle > button {
    font-size: 1.2rem;
  }
}
@media screen and (min-width: 1440px) {
  .bannerTitle {
    margin-top: 14rem;
  }
  .bannerTitle > h1 {
    font-size: 3rem;
    margin: 0 0 50px 0;
  }
  .bannerTitle > p {
    font-size: 1.4rem;
    margin: 0 0 30px 0;
  }
  .bannerTitle > button {
    font-size: 1.2rem;
  }
}
.service_box {
  .swiper-container {
    width: 100%;
    height: 540px;
    overflow: hidden;
    padding: 0.625rem;
    box-sizing: border-box;
    position: relative;

    .swiper-slide {
      width: 30%;
      height: 460px;
      display: flex;
      padding: 0 0 1.875rem 0;
      box-sizing: border-box;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      border-radius: 10px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 20px 1px rgba(63, 156, 250, 0.25);
      overflow: hidden;

      > img {
        width: 100%;
      }

      > h3 {
        font-size: 1.25rem;
        font-weight: 600;
        color: #2c3e50;
        letter-spacing: 2px;
        margin-top: 40px;
      }

      > p {
        max-width: 232px;
        text-align: center;
        font-size: 0.875rem;
        margin-bottom: 10px;
        line-height: 24px;
      }
    }

    .swiper-pagination {
      position: absolute;
      bottom: 20px; /* 距离底部的距离，可按需调整 */
      left: 50%;
      transform: translateX(-50%);
      width: auto;
      display: flex;
      gap: 8px; /* 分段块之间的间距，匹配图中效果 */
      z-index: 999;
    }
    /* 未激活的分段块：浅色、圆角 */
    .swiper-pagination-bullet {
      width: 20px; /* 分段块宽度，匹配图中效果 */
      height: 8px; /* 分段块高度，匹配图中效果 */
      margin: 0;
      border-radius: 4px; /* 圆角，还原图中样式 */
      background: #e0e0e0; /* 浅灰底色，对应图中浅色块 */
      opacity: 1; /* 取消默认透明 */
      transition: all 0.3s ease; /* 切换动画 */
    }

    /* 激活的分段块：深色、高亮 */
    .swiper-pagination-bullet-active {
      background: #40bfff; /* 蓝色底色，对应图中深色块 */
      opacity: 1;
      width: 30px; /* 激活状态宽度增加，匹配图中效果 */
    }

    /* 额外自定义类，避免样式冲突（可选） */
    .swiper-pagination-bullet-custom {
      border: none;
      outline: none;
    }
  }
}

.business_box {
  .business_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    > li {
      width: 46%;
      height: 226.74px;
      opacity: 1;
      border-radius: 10px 0 0 10px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: space-between;
      > div {
        text-align: left;
        margin-left: 20px;
        > h1 {
          font-size: 1.25rem;
          font-weight: 600;
          letter-spacing: 1px;
          color: rgba(9, 15, 25, 1);
          margin: 40px auto 30px;
        }
        > p {
          width: 90%;
          font-size: 0.875rem;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          line-height: 24px;
          display: -webkit-box;
          -webkit-line-clamp: 3; /* 核心：显示3行 */
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          /* 建议加上，避免行高不统一导致计算错误 */
          line-height: 1.6;
          word-break: break-all;
        }
      }
      > img {
        width: 268px;
        height: 227px;
        margin-left: 10px;
      }
    }
    > li:nth-child(3),
    > li:nth-child(4),
    > li:nth-child(5),
    > li:nth-child(6) {
      margin-top: 40px;
    }
  }
}

.teacher_box {
  overflow: hidden;
  padding-bottom: 1rem;

  .teacher_info {
    width: 100%;
    height: 440px;

    background-size: 100%;
    border-radius: 10px;
    box-shadow: 0px 2px 30px 1px rgba(168, 168, 168, 0.25);
    text-align: left;
    overflow: hidden;

    > h1 {
      font-size: 1.5rem;
      color: rgba(0, 0, 0, 1);
      margin: 100px 0 0 8.75rem;
      letter-spacing: 1px;
    }
    > p {
      max-width: 380px;
      font-size: 1rem;
      font-weight: 400;
      line-height: 28px;
      margin: 20px 0 62px 8.75rem;
      letter-spacing: 1px;
    }
    > button {
      font-weight: 400;
      color: #fff;
      padding: 0.75rem 1.875rem;
      border-radius: 20px;
      letter-spacing: 2px;
      font-size: 0.875rem;
      margin-left: 8.75rem;
    }
  }
}

.customer_box {
  .customer_list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 20px;

    .customer_item {
      width: 250px;
      height: 520px;
      opacity: 1;
      text-align: left;
      border-radius: 40px;
      background: rgba(247, 248, 250, 1);
      padding: 1.875rem;
      box-sizing: border-box;
      transition: width 0.1s ease;
      position: relative;
      overflow: hidden;

      > h3 {
        font-size: 2.5rem;
        font-weight: 400;
        color: #2c3e50;
        margin: 20px 0;
        transition: font-size 0.1s ease, transform 0.1s ease;
      }
      > h4 {
        font-weight: 400;
        font-size: 1.375rem;
        color: #2c3e50;
        margin: 0 0 20px 0;
        transition: font-size 0.1s ease, transform 0.1s ease;
      }
      > p {
        font-size: 0.875rem;
        font-weight: 400;
        color: #2c3e50;
        transition: font-size 0.1s ease, transform 0.1s ease;
      }
      > img:first-child {
        transition: width 0s ease, height 0s ease, transform 0s ease,
          position 0s ease;
      }
      > img:last-child {
        width: 90%;
        border-radius: 20px;
        margin-top: 30px;
        transition: width 0s ease;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .customer_item:hover {
      box-shadow: 0px 2px 20px 1px rgba(63, 156, 250, 0.25);
    }

    .customer_item.active {
      width: 400px;
      position: relative;

      > img:first-child {
        position: absolute;
        top: 30px;
        right: 30px;
        transform: translate(0, 0);
      }
      > h3,
      > h4,
      > p {
        transform: translateY(-20px);
      }
    }
  }
}
.cooperation_box {
  .cooperation_list {
    width: 100%;
    .cooperation_item {
      width: 100%;
      height: 120px;
      margin-bottom: 40px;
      overflow: hidden;
      position: relative;
      .scroll-box {
        display: flex;
        width: 100%;
        height: 100%;
        .scroll-content {
          display: flex;
          align-items: center;
          gap: 30px; // 原始内容的图片间距
          flex-shrink: 0; // 关键：防止内容被压缩

          // 给克隆出来的第二份内容，也加上和第一份完全一样的间距
          & + .scroll-content {
            margin-left: 30px; // 关键：在两份内容之间加30px间距
          }

          img {
            width: 220px;
            height: 120px;
            border-radius: 10px;
            flex-shrink: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
}

// 新增：滚动动画关键帧
@keyframes scrollLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%); // 滚动到复制内容的起点（无缝循环）
  }
}

.page_nav {
  width: 100%;
  position: relative;
  z-index: 9;
  margin: -30px auto 0 !important;

  > ul {
    width: 930px;
    height: 60px;
    border-radius: 50px;
    background: #fff;
    box-shadow: 0px 1px 30px rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    > li {
      width: 180px;
      line-height: 50px;
      opacity: 1;
      border-radius: 25px;
      box-sizing: border-box;
      font-size: 1.125rem;
      font-weight: 400;
      cursor: pointer;
    }
    > li.active {
      background: rgba(228, 245, 255, 1);
      color: rgba(7, 70, 255, 1);
      border: 1px solid rgba(228, 245, 255, 1);
    }
  }
  &.fixed {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 998;
    padding: 0.625rem 0;
    margin: 0 auto !important;
  }
}
</style>
